import(/* webpackMode: "eager" */ "/home/crazysal/prd-a/cs-mobile-next/app/(main)/error.tsx");
